import React from 'react';

const TabBar = ({ tabs, activeTab, onChange, className = '' }) => (
  <div className={`bg-white dark:bg-dark-800 rounded-2xl shadow-card border border-gray-100 dark:border-dark-700 overflow-hidden ${className}`}>
    <div className="flex border-b border-gray-100 dark:border-dark-700 overflow-x-auto">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className={`px-6 py-4 text-sm font-medium whitespace-nowrap transition-all flex items-center gap-2 ${
            activeTab === tab.id
              ? 'text-primary-600 border-b-2 border-primary-600 bg-primary-50/50 dark:bg-primary-900/20'
              : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
          }`}
        >
          {tab.icon && <span className="inline-flex items-center gap-2">{tab.icon}</span>}
          <span>{tab.label}</span>
          {tab.badge !== undefined && tab.badge !== null && (
            <span className={`px-1.5 py-0.5 text-xs font-bold rounded-full ${
              activeTab === tab.id
                ? 'bg-primary-100 text-primary-700 dark:bg-primary-900/40 dark:text-primary-400'
                : 'bg-gray-100 text-gray-600 dark:bg-dark-700 dark:text-gray-400'
            }`}>
              {tab.badge}
            </span>
          )}
        </button>
      ))}
    </div>
  </div>
);

export const PillTabs = ({ tabs, activeTab, onChange, className = '' }) => (
  <div className={`flex gap-1 bg-gray-100 dark:bg-dark-700 p-1 rounded-xl w-fit ${className}`}>
    {tabs.map((tab) => (
      <button
        key={tab.id}
        onClick={() => onChange(tab.id)}
        className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2 ${
          activeTab === tab.id
            ? 'bg-white dark:bg-dark-800 text-primary-600 shadow-sm'
            : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
        }`}
      >
        <span>{tab.label}</span>
        {tab.badge !== undefined && tab.badge !== null && (
          <span className={`px-1.5 py-0.5 text-xs font-bold rounded-full ${
            activeTab === tab.id
              ? 'bg-primary-50 text-primary-600 dark:bg-primary-900/40 dark:text-primary-400'
              : 'bg-gray-200 text-gray-600 dark:bg-dark-600 dark:text-gray-400'
          }`}>
            {tab.badge}
          </span>
        )}
      </button>
    ))}
  </div>
);

export default TabBar;
